/**
 * ============================================================================
 * BAMBOOVE — BỘ TRA RIÊNG (16/10/2026 · phiên 75i)
 * ----------------------------------------------------------------------------
 * Chủ dự án: "đánh từng chữ — 'c' ra mọi sản phẩm có chữ c trong TÊN; 'co' ra dòng
 * có 'co'…; chữ khớp được TÔ SÁNG; không có thì 'No results found for "…". Try another search.'"
 * Shopify gốc KHÔNG tìm được đoạn GIỮA của từ ⇒ lọc NGAY TRÊN MÁY KHÁCH từ danh bạ
 * JSON [data-bb-tk-index] (Liquid đổ ra — giá đã ĐÚNG tiền tệ đang xem).
 * Mở modal: nút 🔍 header + ô Search trang kết quả (assets/bamboove-search-mo.js).
 * ============================================================================
 */
(function () {
  'use strict';

  var goc = document.querySelector('[data-bb-tk]');
  if (!goc || goc.dataset.bbTkReady === '1') return;
  goc.dataset.bbTkReady = '1';

  var form = goc.querySelector('[data-bb-tk-form]');
  var nhap = goc.querySelector('[data-bb-tk-nhap]');
  var nutXoa = goc.querySelector('[data-bb-tk-xoa]');
  var nutDong = goc.querySelector('[data-bb-tk-dong]');
  var kq = goc.querySelector('[data-bb-tk-kq]');
  var index = [];
  try {
    index = JSON.parse((goc.querySelector('[data-bb-tk-index]') || {}).textContent || '[]');
  } catch (e) {
    index = [];
  }

  var TOI_DA = 8;

  /* ---------------------------------------------------------------------------
     (75j) "RECENT SEARCHES" — từ khoá khách ĐÃ BẤM TÌM (lưu trong máy khách).
     Chủ dự án: "khoảng trắng dưới dành cho từ khoá đã tra hả… làm cái kiểu đó đi,
     lần sau mở thanh tìm kiếm sẽ hiển thị cụm đấy". Tối đa 6 cụm, mới nhất đứng đầu.
     --------------------------------------------------------------------------- */
  var KHOA_TRA = 'bb_tim_kiem_da_tra';

  function docDaTra() {
    try { return JSON.parse(localStorage.getItem(KHOA_TRA) || '[]') || []; } catch (e) { return []; }
  }

  function luuDaTra(t) {
    t = String(t || '').trim();
    if (!t) return;
    var ds = docDaTra().filter(function (x) { return String(x).toLowerCase() !== t.toLowerCase(); });
    ds.unshift(t);
    ds = ds.slice(0, 6);
    try { localStorage.setItem(KHOA_TRA, JSON.stringify(ds)); } catch (e) { /* thoi */ }
  }

  function veDaTra() {
    var ds = docDaTra();
    if (!ds.length) { kq.innerHTML = ''; return; }
    var html = ['<div class="bb-tk__da-tra"><p class="bb-tk__nhan">Recent searches</p><div class="bb-tk__chips">'];
    ds.forEach(function (t) {
      html.push('<button type="button" class="bb-tk__chip" data-bb-tk-chip="' + esc(t) + '">' + esc(t) + '</button>');
    });
    html.push('</div></div>');
    kq.innerHTML = html.join('');
  }

  /* (75j) ỦY QUYỀN sự kiện cho chip "Recent searches": gắn MỘT LẦN ở khối kết quả —
     vừa không mất khi khối được vẽ lại, vừa stopPropagation để dialog không hiểu nhầm
     "bấm ra ngoài" (vẽ lại DOM ngay trong lượt bấm làm phần tử bị ngắt khỏi cây DOM). */
  if (kq) {
    kq.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-bb-tk-chip]') : null;
      if (!b) return;
      e.stopPropagation();
      nhap.value = b.getAttribute('data-bb-tk-chip');
      ve(nhap.value);
      nhap.focus();
    });
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Tô sáng MỌI đoạn chữ khớp trong tên (75j: bản đầu chỉ tô đoạn ĐẦU — chủ dự án muốn tô HẾT) */
  function tenToSang(ten, tu) {
    var lower = ten.toLowerCase();
    var tim = lower.indexOf(tu);
    if (tim < 0) return esc(ten);
    var out = '';
    var i = 0;
    while (tim >= 0) {
      out += esc(ten.slice(i, tim)) + '<mark>' + esc(ten.slice(tim, tim + tu.length)) + '</mark>';
      i = tim + tu.length;
      tim = lower.indexOf(tu, i);
    }
    return out + esc(ten.slice(i));
  }

  function ve(term) {
    var t = (term || '').trim().toLowerCase();
    if (!t) {
      veDaTra();   /* (75j) ô trống ⇒ hiện "Recent searches" đổ vào khoảng trống */
      if (nutXoa) nutXoa.hidden = true;
      return;
    }
    if (nutXoa) nutXoa.hidden = false;

    var khop = index.filter(function (p) {
      return String(p.t || '').toLowerCase().indexOf(t) >= 0;
    });

    if (!khop.length) {
      kq.innerHTML =
        '<p class="bb-tk__trong">No results found for &quot;' +
        esc(term.trim()) +
        '&quot;. Try another search.</p>';
      return;
    }

    var html = ['<ul class="bb-tk__ds">'];
    khop.slice(0, TOI_DA).forEach(function (p) {
      html.push(
        '<li><a class="bb-tk__mon" href="' + esc(p.u) + '">' +
          (p.a ? '<span class="bb-tk__anh"><img src="' + esc(p.a) + '" alt="" loading="lazy" width="48" height="60"></span>' : '') +
          '<span class="bb-tk__ten">' + tenToSang(String(p.t), t) + '</span>' +
          (p.g ? '<span class="bb-tk__gia">' + esc(p.g) + '</span>' : '') +
        '</a></li>'
      );
    });
    html.push('</ul>');
    html.push(
      '<div class="bb-tk__chan"><button type="button" class="button bb-tk__xem-het" data-bb-tk-xem-het>View all' +
        (khop.length > TOI_DA ? ' (' + khop.length + ')' : '') +
        '</button></div>'
    );
    kq.innerHTML = html.join('');

    var nutHet = kq.querySelector('[data-bb-tk-xem-het]');
    if (nutHet) {
      nutHet.addEventListener('click', function (e) {
        if (e && e.stopPropagation) e.stopPropagation();   /* (75j) không để dialog hiểu nhầm là "bấm ra ngoài" */
        luuDaTra(nhap ? nhap.value : '');   /* (75j) lưu từ khoá đã bấm tìm */
        if (form) form.submit();   /* sang trang kết quả với đúng từ đang gõ */
      });
    }
  }

  if (nhap) nhap.addEventListener('input', function () { ve(nhap.value); });

  /* (75j) Enter (hoặc đường submit nào khác của form) ⇒ lưu từ khoá vào "Recent searches" */
  if (form) {
    form.addEventListener('submit', function () { luuDaTra(nhap ? nhap.value : ''); });
  }

  if (nutXoa) {
    nutXoa.addEventListener('click', function () {
      nhap.value = '';
      nhap.focus();
      ve('');
    });
  }

  if (nutDong) {
    nutDong.addEventListener('click', function () {
      var modal = document.getElementById('search-modal');
      if (modal && typeof modal.closeDialog === 'function') { modal.closeDialog(); return; }
      var dlg = goc.closest('dialog');
      if (dlg) dlg.close();
    });
  }

  /* Mở modal ⇒ đưa con trỏ vào ô nhập · Đóng ⇒ dọn sạch */
  var dlg = goc.closest('dialog');
  if (dlg) {
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        if (dlg.open) {
          window.setTimeout(function () {
            if (nhap) nhap.focus();
            ve('');   /* (75j) mở modal ⇒ dọn kết quả + hiện lại "Recent searches" mới nhất */
          }, 60);
        }
      }).observe(dlg, { attributes: true, attributeFilter: ['open'] });
    }
    dlg.addEventListener('close', function () {
      if (nhap) nhap.value = '';
      ve('');
    });
  }
})();

/* (75j) — dòng chú thích vô hại (đánh dấu lần chạm file để theme dev thử upload lại). */
